import { authenticatedProApiFetch } from "./pro-api.client";

export const ROADMAP_STATUSES = ["known_bug", "planned", "in_progress", "done"] as const;
export const ROADMAP_PRIORITIES = ["p1", "p2", "p3"] as const;
export const ROADMAP_COMPLEXITIES = ["s", "m", "l", "xl"] as const;
export const ROADMAP_ORIGINS = ["roadmap", "new", "added"] as const;

export type RoadmapStatus = (typeof ROADMAP_STATUSES)[number];
export type RoadmapPriority = (typeof ROADMAP_PRIORITIES)[number];
export type RoadmapComplexity = (typeof ROADMAP_COMPLEXITIES)[number];
export type RoadmapOrigin = (typeof ROADMAP_ORIGINS)[number];

export interface RoadmapItem {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  status: RoadmapStatus;
  priority: RoadmapPriority | null;
  complexity: RoadmapComplexity | null;
  category: string | null;
  origin: RoadmapOrigin | null;
  smartSource: string | null;
  sortOrder: number;
  createdBy: string | null;
  createdByName: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface RoadmapItemPayload {
  name: string;
  description: string | null;
  status: RoadmapStatus;
  priority: RoadmapPriority | null;
  complexity: RoadmapComplexity | null;
  category: string | null;
  origin: RoadmapOrigin | null;
  smartSource: string | null;
}

export async function fetchRoadmapItems(accessToken: string): Promise<RoadmapItem[]> {
  return authenticatedProApiFetch<RoadmapItem[]>("/roadmap", accessToken, { method: "GET" });
}

export async function createRoadmapItem(
  accessToken: string,
  payload: RoadmapItemPayload,
): Promise<RoadmapItem> {
  return authenticatedProApiFetch<RoadmapItem>("/roadmap", accessToken, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateRoadmapItem(
  accessToken: string,
  id: string,
  payload: Omit<RoadmapItemPayload, "status">,
): Promise<RoadmapItem> {
  return authenticatedProApiFetch<RoadmapItem>(`/roadmap/${id}`, accessToken, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function moveRoadmapItem(
  accessToken: string,
  id: string,
  status: RoadmapStatus,
  index: number,
): Promise<RoadmapItem> {
  return authenticatedProApiFetch<RoadmapItem>(`/roadmap/${id}/move`, accessToken, {
    method: "POST",
    body: JSON.stringify({ status, index }),
  });
}

export async function deleteRoadmapItem(accessToken: string, id: string): Promise<void> {
  await authenticatedProApiFetch<{ ok: boolean }>(`/roadmap/${id}`, accessToken, {
    method: "DELETE",
  });
}
